import { Component, createSignal, For, onMount, Show } from "solid-js"
import { Artwork, TimelineFilter } from "../types";
import 'medium-zoom/dist/style.css';
import { Timeline } from "../components/timeline";
import { IconTrash } from "@tabler/icons-solidjs";

type Props = {
    artwork: Artwork;
}
type Tab = {
    index: number;
    name: string;
    filter: TimelineFilter;
}

export const TimelineTab : Component<Props> = (props) => {
    const [tabIndex, setTabIndex] = createSignal<number>(0);
    const [tabs, setTabs] = createSignal<Tab[]>([]);
    onMount(async () => {
        const artist = props.artwork.artist;
        const name = artist.firstName && artist.lastName ? artist.firstName + " " + artist.lastName : " the artist";
        const dates = artist.dateRange?.split("-") || [];
        const fromYear = dates.length && dates[0] || "";
        const toYear = dates.length == 2 ? dates[1] : fromYear;
        setTabs([{
            index: 0,
            name: "Timeline of " + name,
            filter: {
                ArtistId: artist.id + "",
                ArtistName: name,
                FromYear: fromYear,
                ToYear: toYear
            }
        }]);
    });
    const loadNewTab = async (name: string, filter: TimelineFilter) => {
        const index = tabs().length;
        const newTab = {
            index: index,
            name,
            filter
        };
        setTabs([...tabs(), newTab]);
        setTabIndex(index);
    };
    const closeTab = (index: number) => {
        const remaining = tabs()
            .filter(x => x.index != index)
            .map((tab, index) => ({ ...tab, index: index }));
        if (remaining.length == 0) {
            return;
        }
        const maxIndex = remaining.length - 1;
        setTabs(remaining);
        setTabIndex(index >= maxIndex ? maxIndex : index);
    }
    return (
        <>
            <section class="tabs air-gap">
                <ul class="list-inline tablinkgroup unselectable">
                    <For each={tabs()}>{(tab, index) =>
                        <li classList={{ ["active"]: tab.index == tabIndex() }}>
                            <span class="tablink" style="color: #333;" onClick={(e) => { e.preventDefault(); setTabIndex(index()); }}>{tab.name}</span>
                            <Show when={index() > 0}>
                                &nbsp;<button class="btn btn-default btn-sm" onClick={(e) => { e.preventDefault(); closeTab(tab.index)}}><IconTrash /></button>
                            </Show>
                        </li>
                    }</For>
                </ul>
            </section>
            <div class="tabgroup">
                <For each={tabs()}>{(tab) =>
                    <Show when={tab.index == tabIndex()}>
                        <div class="tab-pane active">
                            <Timeline filter={tab.filter} onLoadNewTab={loadNewTab} />
                        </div>
                    </Show>
                }</For>
            </div>
        </>
    )
}